import { S3_CDN } from "@/constants/API";
import apiClient from "@/utils/axios";

const SERVICE_ENDPOINT = "storages";

interface PresignedUrlRequest {
  filePath: string;
  fileName: string;
  contentType?: string;
}

const getPresignedUrl = async (fileInfo: PresignedUrlRequest) => {
  const response = await apiClient.post<{ data: string }>(
    `/${SERVICE_ENDPOINT}/presigned-url`,
    fileInfo,
  );
  return response.data.data;
};

const uploadFile = async (
  file: File,
  filePath: string,
  fileName: string,
  contentType: string,
) => {
  try {
    const presignedUrl = await getPresignedUrl({
      filePath,
      fileName,
      contentType,
    });

    const response = await fetch(presignedUrl, {
      method: "put",
      headers: {
        "Content-Type": contentType,
      },
      body: file,
    });

    return presignedUrl;
  } catch (error) {
    console.error(error);
  }
};

const getURLFromPath = (path?: string, timestamp: boolean = false) => {
  if (!path) return "";
  return `${S3_CDN}/${path}` + (timestamp ? `?t=${Date.now()}` : "");
};

const storageApi = {
  getPresignedUrl,
  uploadFile,
  getURLFromPath,
};
export default storageApi;
